<h2 mat-dialog-title class="amc__title" autoTranslate>Aplicar em quais empresas?</h2>

<mat-dialog-content class="amc__content">
    <p class="amc__lead">
        <span autoTranslate>Você vai</span> {{ actionLabel | autoTranslate }}.
        <span autoTranslate>Marque as empresas em que esta ação deve valer:</span>
    </p>

    <div class="amc__list">
        <label class="amc__item" *ngFor="let option of options">
            <mat-checkbox [(ngModel)]="option.selected" [disabled]="option.locked"></mat-checkbox>
            <span class="amc__name">
                {{ option.name }}
                <span class="amc__badge" *ngIf="option.locked" autoTranslate>(atual)</span>
            </span>
        </label>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="amc__actions">
    <button mat-stroked-button type="button" (click)="cancel()">
        <span autoTranslate>Cancelar</span>
    </button>
    <button mat-flat-button color="primary" type="button" [disabled]="!canConfirm" (click)="confirm()">
        <span autoTranslate>Confirmar</span>
    </button>
</mat-dialog-actions>
